'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var emptyFunc = function emptyFunc() {};

exports.emptyFunc = emptyFunc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-tabs/lib/utils.js
// module id = 152
// module chunks = 0